import { DatePicker } from 'antd';
import dayjs from 'dayjs';

/**
 * Combined date + time picker for gate passes, event windows, exam slots.
 * Stores ISO 8601 (`2026-09-18T15:30:00.000Z`); displays local time.
 */
interface Props {
  value?: string;
  onChange?: (value: string | undefined) => void;
  disabled?: boolean;
  placeholder?: string;
  minuteStep?: 1 | 5 | 10 | 15 | 30;
  status?: 'error' | 'warning';
  id?: string;
}

export function DateTimeField({ value, onChange, placeholder, minuteStep = 5, ...rest }: Props) {
  const parsed = value ? dayjs(value) : null;
  const dayjsValue = parsed && parsed.isValid() ? parsed : null;

  return (
    <DatePicker
      showTime={{ format: 'HH:mm', minuteStep }}
      value={dayjsValue}
      onChange={(d) => onChange?.(d ? d.toISOString() : undefined)}
      format="DD MMM YYYY, HH:mm"
      placeholder={placeholder ?? 'Pick date & time'}
      allowClear
      style={{ width: '100%' }}
      {...rest}
    />
  );
}
